/**
 * 培训管理  签到情况
 */
<template>
  <div style="background-color: white; padding: 10px; border-radius: 5px; height: 93vh; overflow-y: auto">
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>课程表管理</el-breadcrumb-item>
    </el-breadcrumb>-->


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.name" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.idcard" placeholder="输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.phone" placeholder="输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="" v-if="type == 1">
        <el-select size="small" v-model="queryParams.sfqd" clearable placeholder="请选择签到状态">
          <el-option label="已签到" :value="1"></el-option>
          <el-option label="未签到" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" v-if="type == 2">
        <el-select size="small" v-model="queryParams.sfqd" clearable placeholder="请选择签退状态">
          <el-option label="已签退" :value="1"></el-option>
          <el-option label="未签退" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="photo" label="签到照片" width="80">
        <template slot-scope="scope">
          <el-image
            style="width: 40px"
            :src="scope.row.photo"
            v-if="scope.row.photo"
            :preview-src-list="[scope.row.photo]"
            fit="fit">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="idcard" label="身份证号"/>
      <el-table-column prop="phone" label="手机号码"/>
      <el-table-column prop="dkfs" label="签到方式" v-if="type == 1">
        <template slot-scope="scope">
          <div>{{scope.row.dkfs == 1 ? '手机签到' : scope.row.dkfs == 2 ? '设备签到' : scope.row.dkfs == 3 ? '设备/手机签到' : '未签到'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="签到时间" v-if="type == 1"/>
      <el-table-column prop="dkfs" label="签退方式" v-if="type == 2">
        <template slot-scope="scope">
          <div>{{scope.row.dkfs == 1 ? '手机签退' : scope.row.dkfs == 2 ? '设备签退' : scope.row.dkfs == 3 ? '设备/手机签退' : '未签退'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="签退时间" v-if="type == 2"/>

      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="上传"
            placement="top"
            v-if="!scope.row.photo"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleUpload(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" top="5vh" :close-on-click-modal="false" @click="editFormShow = false" append-to-body>
      <div class="form-add" style="padding-bottom: 30px;">
        <div class="form-add-body">
          <el-form label-width="120px" :model="form" :rules="rules" ref="form">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="头像" prop="photo">
                  <el-upload
                    class="avatar-uploader"
                    :action="url"
                    :data="extraData"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <el-image
                      style="width: 100px; height: 100px"
                      v-if="form.photo"
                      :src="form.photo"
                      fit="cover"></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="type == 1 ? '签到时间' : '签退时间'" prop="createTime">
                  <el-date-picker
                    size="small"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择时间"
                    v-model="form.createTime"
                    style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div slot="footer" class="dialog-footer" style="float: right;">
            <el-button size="small" @click="editFormShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getMarketingChannelList,
  addMarketingChannel,
  editMarketingChannel,
  deleteMarketingChannel,
  getRoomList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {timestampToTime} from "../../utils/util";
import Template from "../../components/template.vue";
import {
  deleteCourseTableById,
  editCourseTable,
  generateCode,
  getCourseTableList,
  queryCourseById
} from "../../api/course";
import {editQdByLesson, editQtByLesson, queryQdByLesson, queryQtByLesson} from "../../api/classInfo";
import AddStudent from "./student/addStudent.vue";
export default {
  data() {
    return {
      loading: false, //是显示加载
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据

      editFormShow: false, //控制编辑页面显示与隐藏
      title: '上传',
      url: '/api/student/upload',
      extraData: {
        sftx: '1'
      },
      form: {},
      rules: {
        photo: [{ required: true, message: '请上传头像', trigger: 'blur' }],
        createTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
      },

      id: '',
      courseItem: {},

      type: 1,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
    }
  },
  // 注册组件
  components: {
    AddStudent,
    Template,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if (this.$route.query.classId) {
      this.queryParams.classId = this.$route.query.classId;
      this.queryParams.courseId = this.$route.query.courseId;
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      this.initData()
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata();
      queryCourseById(this.id).then(res => {
        if (res.code == 200) {
          this.courseItem = res.data;
        }
      })
    },
    // 获取 列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if (this.type == 1) {
        queryQdByLesson(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      } else if (this.type == 2) {
        queryQtByLesson(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      }
    },
    handleUpload(index, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.$set(this.form, 'classId', this.courseItem.classId)
      this.$set(this.form, 'courseId', this.courseItem.courseId)
      this.$set(this.form, 'roomId', this.courseItem.roomId)
      this.editFormShow = true;
    },
    handleAvatarSuccess(res, file) {
      /* URL.createObjectURL(file.raw) */
      this.form.photo = res.data.url;
    },
    beforeAvatarUpload(file) {
      console.log('file===', file);
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          var params = {
            classId: this.form.classId,
            courseId: this.form.courseId,
            roomId: this.form.roomId,
            idcard: this.form.idcard,
            createTime: this.form.createTime,
            photo: this.form.photo
          }
          if (this.type == 1) {
            editQdByLesson(params).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.search()
                this.$message({
                  type: 'success',
                  message: '上传成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.loading = false
              this.$message.error(err.response.data.msg)
            })
          } else if (this.type == 2) {
            editQtByLesson(params).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.search()
                this.$message({
                  type: 'success',
                  message: '上传成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.loading = false
              this.$message.error(err.response.data.msg)
            })
          }
        } else {
          return false
        }
      })
    },

    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/goods/signInStatus.vue